module.exports = __webpack_public_path__ + "img/evolution2.0d4d5e41.png";